import React, { useState, useEffect } from "react";
import styled from "styled-components/macro";
import { Helmet } from "react-helmet-async";
import * as Yup from "yup";
import { Formik } from "formik";

import {
  Button,
  Paper,
  TextField as MuiTextField,
  Typography,
} from "@material-ui/core";
import { spacing } from "@material-ui/system";
import { Alert as MuiAlert } from "@material-ui/lab";

import NewPassword from "./NewPassword";
import { resetPassword } from "../../services/authService";

const Alert = styled(MuiAlert)(spacing);

const TextField = styled(MuiTextField)(spacing);

const Wrapper = styled(Paper)`
  padding: ${(props) => props.theme.spacing(6)}px;

  ${(props) => props.theme.breakpoints.up("md")} {
    padding: ${(props) => props.theme.spacing(10)}px;
  }
`;

function ResetPassword({ match }) {
  const [token, setToken] = useState();

  useEffect(() => {
    if (match.params.token) {
      setToken(match.params.token);
    }
  }, [match.params.token]);

  if (token) {
    return <NewPassword token={token} />;
  }

  return (
    <Wrapper>
      <Helmet title="Esqueci a Senha" />

      <Typography component="h1" variant="h4" align="center" gutterBottom>
        Esqueci a Senha
      </Typography>
      <Typography component="h2" variant="body1" align="center">
        Informe seu e-mail para recuperar a senha
      </Typography>

      <Formik
        initialValues={{
          email: "",
          submit: false,
        }}
        validationSchema={Yup.object().shape({
          email: Yup.string()
            .email("O e-mail deve ser válido")
            .max(255, "No máximo 255 caracteres")
            .required("O e-mail é obrigatório"),
        })}
        onSubmit={async (values, { setErrors, setStatus, setSubmitting }) => {
          try {
            const response = await resetPassword({
              email: values.email,
            });
            setStatus({
              success: true,
              message: response.message || "Requisição enviada",
            });
          } catch (error) {
            const message = error.message || "Algo deu errado";

            setStatus({ success: false });
            setErrors({ submit: message });
            setSubmitting(false);
          }
        }}
      >
        {({
          errors,
          handleBlur,
          handleChange,
          handleSubmit,
          isSubmitting,
          touched,
          values,
          status,
        }) => (
          <form noValidate onSubmit={handleSubmit}>
            {errors.submit && (
              <Alert mt={2} mb={1} severity="warning">
                {errors.submit}
              </Alert>
            )}

            {status?.success && (
              <Alert mt={2} mb={1} severity="success">
                {status?.message}
              </Alert>
            )}
            <TextField
              type="email"
              name="email"
              label="E-mail"
              value={values.email}
              error={Boolean(touched.email && errors.email)}
              fullWidth
              helperText={touched.email && errors.email}
              onBlur={handleBlur}
              onChange={handleChange}
              my={3}
            />
            <Button
              type="submit"
              fullWidth
              variant="contained"
              color="primary"
              disabled={isSubmitting}
            >
              Recuperar senha
            </Button>
          </form>
        )}
      </Formik>
    </Wrapper>
  );
}

export default ResetPassword;
